module.exports = __webpack_public_path__ + "static/media/theme_athletics.6bde3789.mp3";